import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API

export const getSpecPromosi = createAsyncThunk(
  "promosiTransaksi/getSpecPromosi",
  async ({ TransaksiApprovalID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("TransaksiApprovalID", TransaksiApprovalID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getSpecPromosi",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getPromosiTransaksi = createAsyncThunk(
  "promosiTransaksi/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getPromosi",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertPromosiTransaksi = createAsyncThunk(
  "promosiTransaksi/insert",
  async (
    { Nik, JenisTransaksi, PosisiBaru, TanggalEfektif, Alasan },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("JenisTransaksi", JenisTransaksi);
    formData.append("PosisiBaru", PosisiBaru);
    formData.append("TanggalEfektif", TanggalEfektif);
    formData.append("Alasan", Alasan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertPromosi",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updatePromosiTransaksi = createAsyncThunk(
  "promosiTransaksi/update",
  async (
    { TPromosiID, Nik, JenisTransaksi, PosisiBaru, TanggalEfektif, Alasan },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("TPromosiID", TPromosiID);
    formData.append("Nik", Nik);
    formData.append("JenisTransaksi", JenisTransaksi);
    formData.append("PosisiBaru", PosisiBaru);
    formData.append("TanggalEfektif", TanggalEfektif);
    formData.append("Alasan", Alasan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updatePromosi",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const deletePromosiTransaksi = createAsyncThunk(
  "promosiTransaksi/delete",
  async ({ TPromosiID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("TPromosiID", TPromosiID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "deletePromosi",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

//INIT
const initialState = {
  message: "",
  SpecPromosiData: [],
  isSpecPromosiFetching: false,
  isSpecPromosiSuccess: false,
  isSpecPromosiError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

//SLICES
export const promosiTransaksiSlice = createSlice({
  name: "promosiTransaksi",
  initialState,
  reducers: {},
  extraReducers: {
    // GET
    [getSpecPromosi.fulfilled]: (state, { payload }) => {
      state.SpecPromosiData = payload.data[0];
      state.isSpecPromosiSuccess = true;
      state.message = payload.message;
      return state;
    },
    [getSpecPromosi.rejected]: (state, { payload }) => {
      state.isSpecPromosiFetching = false;
    },
    [getSpecPromosi.pending]: (state) => {
      state.isSpecPromosiFetching = false;
    },

    [getPromosiTransaksi.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getPromosiTransaksi.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload?.message;
    },
    [getPromosiTransaksi.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertPromosiTransaksi.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      return state;
    },
    [insertPromosiTransaksi.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload?.message;
    },
    [insertPromosiTransaksi.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updatePromosiTransaksi.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      return state;
    },
    [updatePromosiTransaksi.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message;
    },
    [updatePromosiTransaksi.pending]: (state) => {
      state.isUpdateFetching = true;
    },

    // DELETE
    [deletePromosiTransaksi.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      return state;
    },
    [deletePromosiTransaksi.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message;
    },
    [deletePromosiTransaksi.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const promosiTransaksiSelector = (state) => state.promosiTransaksi;
